import loadable from '@loadable/component'

export const Criteria = loadable(() => import('./Criteria'))
export { default as criteriaMocks } from './__mocks__/Criteria.mock'
export type { CriteriaItemProps, CriteriaProps } from './Criteria'
